import { action, makeAutoObservable } from 'mobx';

import useStore from '@/common/hooks/useStore';
import Diamond from '@/product/entity/Diamond';

import ReferenceAPI from '../api/ReferenceAPI';

class ReferenceStore {
  showReference = false;

  private readonly referenceAPI: ReferenceAPI;

  constructor() {
    makeAutoObservable<ReferenceStore, 'referenceAPI'>(this, {
      referenceAPI: false,
      referenceMap: false,
    });

    this.referenceAPI = new ReferenceAPI();
  }

  referenceMap: Record<number, Diamond> = {};

  fetch(product: Diamond) {
    if (product.carat === 0) {
      return Promise.resolve(null);
    }

    if (this.referenceMap[product.carat]) {
      return Promise.resolve(this.referenceMap[product.carat]);
    }

    return this.referenceAPI.fetchItem(product).then(
      action((res) => {
        this.referenceMap[product.carat] = new Diamond(res.content);

        return this.referenceMap[product.carat];
      }),
    );
  }

  setShowReference = (showReference: boolean) => {
    this.showReference = showReference;
  };

  toggleShowReference = () => {
    this.setShowReference(!this.showReference);
  };
}

export const useReferenceStore = () => useStore(ReferenceStore);

export const referenceStore = new ReferenceStore();
export default ReferenceStore;
